/* eslint-disable @typescript-eslint/no-explicit-any */
const baseState = {
  error: null,
  fetching: false,
  fetched: false,
};

export default baseState;

export interface BaseStateInterface {
  error: any;
  fetching: boolean;
  fetched: boolean;
}
